import React from 'react'

import { CardBasicIcon } from '@arcade/web/icons/react'
import { IconMat } from '@cash-design-system/react'

export const DisclaimerIcon = () => (
  <IconMat>
    <CardBasicIcon size={32} />
  </IconMat>
)

export default DisclaimerIcon
